export default __webpack_public_path__ + "static/media/R_Forms.3108b422.png";